var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicScroller',{attrs:{"id":"public-list","items":_vm.indices,"min-item-size":173},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
var active = ref.active;
return [_c('DynamicScrollerItem',{attrs:{"item":item,"active":active,"size-dependencies":[_vm.getWindowWidth(), item],"index":index}},[_c('edition-public-row',{key:item,staticStyle:{"min-height":"173px"},attrs:{"editions":_vm.editions,"index":item}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }